// src/components/FloatingInstagramBar.jsx
import React from 'react';
import { Box, Link as MuiLink, Container } from '@mui/material';

const DEFAULT_ICON =
  'https://img.icons8.com/?size=100&id=Xy10Jcu1L2Su&format=png&color=000000';

const FloatingInstagramBar = ({
  href = 'https://www.instagram.com/ferracort__?igsh=b3d3dHc3NmhtcmMz',
  label = 'Visita nuestro Instagram',
  zIndex = 2000,
  bottom = 10,          // un poco separado del borde
  showLabelOnMobile = true,
  icon = DEFAULT_ICON,
}) => {
  return (
    <Box
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom,
        zIndex,
        // 🔻 sin “vidrio”: todo transparente y sin sombras
        height: 'auto',
        background: 'transparent',
        backdropFilter: 'none',
        borderTop: 'none',
        boxShadow: 'none',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
        }}
      >
        <MuiLink
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Abrir Instagram"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 1,
            px: 2,
            py: 1,
            borderRadius: 999,
            textDecoration: 'none',
            color: '#111',
            // ✅ mantenemos el amarillo del botón
            background: 'linear-gradient(180deg, #F3D462 0%, #DAA520 100%)',
            boxShadow:
              'inset 0 1px 0 rgba(255,255,255,.35), 0 12px 24px rgba(218,165,32,.25)',
            transition: 'transform .15s ease, box-shadow .25s ease',
            '&:hover': { transform: 'translateY(-2px)' },
          }}
        >
          <Box component="img" src={icon} alt="Instagram" width={20} height={20} />
          <Box
            component="span"
            sx={{
              display: { xs: showLabelOnMobile ? 'inline' : 'none', sm: 'inline' },
              fontWeight: 900,
              letterSpacing: '.03em',
              fontSize: 14,
              whiteSpace: 'nowrap',
            }}
          >
            {label}
          </Box>
        </MuiLink>
      </Container>
    </Box>
  );
};

export default FloatingInstagramBar;
